"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormArray = exports["default"] = exports.FormField = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormField = /*#__PURE__*/function () {
  function FormField() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? '' : _ref$name,
        _ref$validators = _ref.validators,
        validators = _ref$validators === void 0 ? [] : _ref$validators,
        _ref$errors = _ref.errors,
        errors = _ref$errors === void 0 ? [] : _ref$errors,
        _ref$value = _ref.value,
        value = _ref$value === void 0 ? '' : _ref$value;

    _classCallCheck(this, FormField);

    _defineProperty(this, "_value", null);

    _defineProperty(this, "_errors", []);

    _defineProperty(this, "_validators", []);

    Object.assign(this, {
      _validators: validators,
      _errors: errors,
      _value: Array.isArray(value) ? _toConsumableArray(value) : typeof value !== null && _typeof(value) == 'object' ? _objectSpread({}, value) : value,
      name: name
    });
  }

  _createClass(FormField, [{
    key: "validate",
    value: function validate() {
      var _this = this;

      this.errors = [];
      this.validators.map(function (val) {
        if (!val) {
          // fails if null is added to list of validators
          return;
        }

        try {
          val.call(_this.value);
        } catch (e) {
          var err = JSON.parse(e.message);

          _this.errors.push(err);
        }
      });
    }
  }, {
    key: "addValidator",
    value: function addValidator(validator) {
      var __validators = _toConsumableArray(this.validators);

      __validators.push(validator);

      this._validators = __validators;
    }
  }, {
    key: "isValid",
    get: function get() {
      var _this2 = this;

      try {
        this.validators.forEach(function (v) {
          v.call(_this2.value);
        });
      } catch (e) {
        return false;
      }

      return true;
    }
  }, {
    key: "errors",
    get: function get() {
      return this._errors;
    },
    set: function set(error) {
      this._errors = error;
    }
  }, {
    key: "value",
    set: function set(value) {
      this._value = value;
    },
    get: function get() {
      return this._value;
    }
  }, {
    key: "validators",
    get: function get() {
      return this._validators;
    },
    set: function set(validator) {
      this.validators = validator;
    }
  }], [{
    key: "create",
    value: function create() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new FormField(data);
    }
  }]);

  return FormField;
}();

exports.FormField = FormField;

var Form = /*#__PURE__*/function () {
  function Form() {
    var kwargs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Form);

    this._fields = {};
    this._dynamicFormValidators = {};

    for (var prop in this.constructor) {
      if (this.constructor[prop] instanceof FormField) {
        // create a copy of the new Field instance as they point to the same object in memory
        this._fields[prop] = this.copy(this.constructor[prop]);
      }

      if (this.constructor[prop] instanceof FormArray) {
        // create a copy of the new FieldArray instance as they point to the same object in memory
        this._fields[prop] = this.copyArray(this.constructor[prop]);
      }

      if (prop == 'dynamicFormValidators') {
        // adds form level validators to fields
        this._dynamicFormValidators = this.constructor[prop];
      }
    }

    for (var fieldName in this._fields) {
      var field = this._fields[fieldName];

      if (field instanceof FormField) {
        // Optionally set the value of the field either from the constructor of the instance
        // or the constructor of the parent form class latest priority first
        field.value = kwargs[fieldName] && !(kwargs[fieldName] instanceof FormField) ? kwargs[fieldName] : field.value;
        field.name = fieldName;
        this[fieldName] = field;
      } else if (field instanceof FormArray) {
        this[fieldName] = field;
      }
    }

    for (var _i = 0, _Object$entries = Object.entries(this._dynamicFormValidators); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          _field = _Object$entries$_i[0],
          _validators = _Object$entries$_i[1];

      for (var i = 0; i < _validators.length; i++) {
        this.addValidator(_field, _validators[i]);
      }
    }
  }

  _createClass(Form, [{
    key: "copy",
    value: function copy() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new FormField(opts);
    }
  }, {
    key: "copyArray",
    value: function copyArray() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var groups = opts.groups.map(function (g) {
        return new g.constructor(g);
      });
      return new FormArray(_objectSpread({}, opts, {
        name: opts.name,
        groups: _toConsumableArray(groups)
      }));
    }
  }, {
    key: "_handleNoFieldErrors",
    value: function _handleNoFieldErrors(fieldName) {
      try {
        var field = this.field[fieldName];

        if (!field) {
          throw new Error(JSON.stringify({
            code: 'no_field',
            message: "".concat(this.constructor.name, " does not contain ").concat(fieldName, " field")
          }));
        }
      } catch (e) {
        throw e;
      }
    }
  }, {
    key: "addToArray",
    value: function addToArray(formArrayName, form) {
      /** Add a new instance of a form to a formarray
       * @fromArrayName requred string name of the formarray to attach to
       * @form new instance of the Form eg new AddressForm
       */
      this._handleNoFieldErrors(formArrayName);

      if (this.field[formArrayName] instanceof FormArray) {
        this.field[formArrayName].add(form);
      }
    }
  }, {
    key: "removeFromArray",
    value: function removeFromArray(formArrayName, index) {
      /** Remove an instance from a FormArray
       * @formArrayName required string name of the formarray
       * @index requred number the index of the instance to remove
       */
      this._handleNoFieldErrors(formArrayName);

      if (this.field[formArrayName] instanceof FormArray) {
        this.field[formArrayName].remove(index);
      }
    }
  }, {
    key: "addValidator",
    value: function addValidator(fieldName, validator) {
      var extraArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      /** Add Validators on the fly to certain fields
       * @fieldName required string the field name to attach a validator to
       * @validator the validator as a new instance
       * @extraArgs if a field is a form array pass in the fieldName of its field
       * Note for formArrays all instances will receive the validator
       */
      this._handleNoFieldErrors(fieldName);

      var props = {};

      for (var prop in validator) {
        props[prop] = validator[prop];
      }

      props['form'] = this;
      var updatedValidatorWithForm = new validator.constructor(props);

      if (this.field[fieldName] instanceof FormArray && extraArgs) {
        this.field[fieldName].groups.forEach(function (g) {
          if (g.field[extraArgs]) {
            g.field[extraArgs].addValidator(updatedValidatorWithForm);
          }
        });
      } else if (this.field[fieldName] instanceof FormField) {
        this.field[fieldName].addValidator(updatedValidatorWithForm);
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      this.fields.forEach(function (f) {
        if (f instanceof FormField) {
          f.validate();
          /*  if (!f.isValid) return (this.isValid = false)
            else return (this.isValid = true) */
        } else if (f instanceof FormArray) {
          f.groups.forEach(function (fg) {
            fg.validate();
          });
        }
      });
    }
  }, {
    key: "field",
    get: function get() {
      // helper getter to return the fields
      // users can access fields with xxx.field['fieldName']
      return this._fields;
    }
  }, {
    key: "fields",
    get: function get() {
      var arr = [];

      for (var fieldName in this._fields) {
        // return an array of fields for easier loop access
        arr.push(this._fields[fieldName]);
      }

      return arr;
    }
  }, {
    key: "errors",
    get: function get() {
      /** Returns an array of field errors in the format name:string, value:string, errors:str[]*/
      try {
        return this.fields.reduce(function (acc, curr) {
          if (curr instanceof FormArray) {
            var groupErrors = curr.groups.reduce(function (groupAcc, groupCurr) {
              if (!groupCurr.isValid || groupCurr.errors.length > 0) {
                if (!groupAcc) {
                  groupAcc = [];
                }

                groupAcc.push({
                  value: curr.value,
                  errors: groupCurr.errors
                });
                return groupAcc;
              }
            }, []);

            if (groupErrors && groupErrors.length > 0) {
              var errorObj = _defineProperty({}, curr.name, groupErrors);

              acc.push(errorObj);
            }
          }

          if (curr instanceof FormField) {
            if (!curr.isValid || curr.errors.length > 0) {
              acc.push({
                name: curr.name,
                value: curr.value,
                errors: curr.errors
              });
              return acc;
            }
          }

          return acc;
        }, []);
      } catch (e) {
        return e;
      }
    },
    set: function set(errs) {
      if (Array.isArray(errs)) {
        this._errors = errs;
      } else {
        this._errors = [errs];
      }
    }
  }, {
    key: "value",
    get: function get() {
      return this.fields.reduce(function (acc, curr) {
        acc[curr.name] = curr.value;
        return acc;
      }, {});
    }
  }, {
    key: "isValid",
    get: function get() {
      var _this3 = this;

      try {
        this.fields.forEach(function (f) {
          if (f instanceof FormField) {
            if (!f.isValid) {
              throw new Error("".concat(f.name, " is invalid"));
            }
          } else if (f instanceof FormArray) {
            f.groups.forEach(function (fg) {
              if (!fg.isValid) {
                throw new Error();
              }
            });
          } else {
            return _this3.isValid;
          }
        });
      } catch (e) {
        return false;
      }

      return true;
    },
    set: function set(valid) {
      this.isValid = valid;
    }
  }]);

  return Form;
}();

exports["default"] = Form;

var FormArray = /*#__PURE__*/function () {
  function FormArray() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$name = _ref2.name,
        name = _ref2$name === void 0 ? '' : _ref2$name,
        _ref2$groups = _ref2.groups,
        groups = _ref2$groups === void 0 ? [new Form()] : _ref2$groups,
        _ref2$value = _ref2.value,
        value = _ref2$value === void 0 ? null : _ref2$value;

    _classCallCheck(this, FormArray);

    _defineProperty(this, "_value", null);

    _defineProperty(this, "_errors", []);

    _defineProperty(this, "_groups", []);

    Object.assign(this, {
      name: name,
      _value: value,
      _groups: groups
    });
  }

  _createClass(FormArray, [{
    key: "add",
    value: function add() {
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Form();

      this._groups.push(group);
    }
  }, {
    key: "remove",
    value: function remove(index) {
      this.groups.splice(index, 1);
      this._groups = this.groups;
    }
  }, {
    key: "value",
    get: function get() {
      return this._groups.map(function (f) {
        return f.value;
      });
    },
    set: function set(value) {
      this._value = value;
    }
  }, {
    key: "groups",
    get: function get() {
      return this._groups;
    }
  }]);

  return FormArray;
}();

exports.FormArray = FormArray;